export default __webpack_public_path__ + "static/media/asteria_large_logos.c4b01fb8.png";